import {AxiosInstance, AxiosResponse} from "axios/index";
import createTimetablesWebApiHttpClient from "./createTimetablesWebApiHttpClient";
import moment from "moment/moment";
import {MOMENT_DATE_FORMAT} from "../constants/date_format";

class MEventApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = createTimetablesWebApiHttpClient();
    }

    async GetEventStatuses() {
        let url = `/mevents/eventstatuses`;
        
        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetCompanies() {
        let url = `/mevents/companies`;

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async PostCompanies(payload: any) {
        let url = `/mevents/company`;

        const { data } = await this.httpClient.post(url, payload);
        return data;
    }
    
    async GetBannerEventsByEventCrn(eventCrn: string) {
        let url = `/mevents/bevent/${eventCrn}`;
        
        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetManagedEvents(eventStaffIds: Array<string>, statusIds: Array<string>, startDate: string, endDate: string) {
        const params = new URLSearchParams();

        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        eventStaffIds?.forEach(id => params.append('staffAccountId', id));
        statusIds?.forEach(id => params.append('eventStatusId', id));

        const queryString = params.toString();
        const url = queryString ? `/mevents/summary?${queryString}` : `/mevents/summary`;

        const { data } = await this.httpClient.get(url);
        return data;
    }
    
    async GetManagedEventsByEventCrn(eventCrn: string) {
        let url = `/mevents/mevent/eventcrn/${eventCrn}`;

        const { data } = await this.httpClient.get(url);
        return data;
    }
    
    async GetManagedEventsById(id: string) {
        let url = `/mevents/mevent/${id}`;
        
        const { data } = await this.httpClient.get(url);
        return data;
    }
    
    async GetClientsByCompanyId(companyId: string) {
        let url = `/mevents/clients/${companyId}`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetClientsByActivity(isActive: boolean) {
        let url = `/mevents/clients?active=${isActive}`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetClients() {
        let url = `/mevents/clients`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async PostClient(payload: any) {
        let url = `/mevents/client`

        const { data } = await this.httpClient.post(url, payload);
        return data;
    }

    async PutClient(payload: any) {
        let url = `/mevents/client`

        const { data } = await this.httpClient.put(url, payload);
        return data;
    }

    async GetItemCategories() {
        let url = `/mevents/itemcategories`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetItems() {
        let url = `/mevents/items`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetStaffs() {
        let url = `/mevents/mevent/accounts`

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async PostManagedEvent(managedEvent: any) {
        const { data } = await this.httpClient.post(`/mevents/mevent`, managedEvent);
        return data;
    }

    async PutManagedEvent(managedEvent: any) {
        const { data } = await this.httpClient.put(`/mevents/mevent`, managedEvent);
        return data;
    }
    
    async PutManagedEventFunction(managedEventFunction: any) {
        const { data } = await this.httpClient.put(`/mevents/meventfunction`, managedEventFunction);
        return data;
    }

    async DeleteManagedEventFunction(maangedEventFunctionId: any) {
        const { data } = await this.httpClient.delete(`/mevents/meventfunction/${maangedEventFunctionId}`);
        return data;
    }
    
    async PutManagedEventFunctionItem(managedEventFunctionItem: any) {
        const { data } = await this.httpClient.put(`/mevents/meventfunctionitem`, managedEventFunctionItem);
        return data;
    }

    async PostManagedEventFunctionItem(managedEventFunctionItem: any) {
        const { data } = await this.httpClient.post(`/mevents/meventfunctionitem`, managedEventFunctionItem);
        return data;
    }

    async DeleteManagedEventFunctionItem(managedEventFunctionItemId: any) {
        const { data } = await this.httpClient.delete(`/mevents/meventfunctionitem/${managedEventFunctionItemId}`);
        return data;
    }
    
    async SyncManagedEventFunctionItems(managedEventId: string, selectedEventFunctionId: string, eventFunctionItems: Array<Object>) {
        const { data } = await this.httpClient.put(`/mevents/meventfunctionitems/sync/${managedEventId}/except/${selectedEventFunctionId}`, eventFunctionItems);
        return data;
    }
    
    async CopyManagedEventFunction(sourceManagedEventId: string, destinationManagedEventId: string) {
        const { data } = await this.httpClient.put(`/mevents/meventfunction/copy/${sourceManagedEventId}/to/${destinationManagedEventId}`);
        return data;
    }
    
    async GetCostSummary(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/costsummary/${id}`)
        return data;
    }
    
    async GetRateCategories(): Promise<Array<any>> {
        const { data } = await this.httpClient.get(`/mevents/ratecategories`);
        return data;
    }

    async GetContractDoc(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/contractDoc/${id}`, { responseType: 'arraybuffer' });

        return data;
    }
    async GetConfirmDoc(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/confirmDoc/${id}`, { responseType: 'arraybuffer' });

        return data;
    }
    async GetQuoteDoc(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/quotedoc/${id}`, { responseType: 'arraybuffer' });

        return data;
    }
    async GetRoomSetupDoc(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/roomSetupDoc/${id}`, { responseType: 'arraybuffer' });

        return data;
    }
    async GetRequestToInvoiceDoc(id: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/requesttoinvoicedoc/${id}`, { responseType: 'arraybuffer' });
        
        return data;
    }
    async GetDoorSignDoc(mEventFunctionId: string) {
        const { data } = await this.httpClient.get(`/mevents/mevent/doorsigndoc/${mEventFunctionId}`, { responseType: 'arraybuffer' });

        return data;
    }

    async ExportManagedEvents(startDate: string, endDate: string): Promise<FileResponse> {
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        const queryString = params.toString();
        // API route is [HttpGet("export/{id}")]; pass 0 to export all events
        const url = queryString ? `/mevents/export/0?${queryString}` : `/mevents/export/0`;

        const fileData = await this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .then(function (response: AxiosResponse) {
                const contentDisposition = response.headers['content-disposition'];
                let fileName = `managed_events_export_${startDate}_${endDate}.xlsx`;

                if (contentDisposition) {
                    fileName = contentDisposition.split(new RegExp('filename=', 'ig'))[1].split(';')[0].replaceAll('"', '').trim();
                }

                const fileType = response.headers['content-type'];
                const fileBlob = new Blob([response.data], { type: fileType });

                return {
                    fileName: fileName,
                    fileBlob: fileBlob,
                    fileType: fileType,
                } as FileResponse;
            });

        return fileData;
    }
}

type FileResponse = {
    fileName: string;
    fileBlob: Blob;
    fileType: string;
};

export default MEventApi;
